import { Link, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as WavelengthIcon } from '../images/wavelength.svg';
import { useState, useEffect } from 'react';
import './Wavelength.css';

function Wavelength() {
  const [gameStarted, setGameStarted] = useState(false);
  const { gameCode } = useParams();
  const navigate = useNavigate();

  // If we have a game code in the URL, start the game immediately
  useEffect(() => {
    if (gameCode) {
      setGameStarted(true);
    }
  }, [gameCode]);

  const handleNewGame = () => {
    // Generate a random 4-digit code if none exists
    if (!gameCode) {
      const randomCode = Math.floor(1000 + Math.random() * 9000).toString();
      navigate(`/wavelength/${randomCode}`);
    } else {
      setGameStarted(true);
    }
  };

  const handleBackToInstructions = () => {
    if (gameCode) {
      navigate('/wavelength');
    } else {
      setGameStarted(false);
    }
  };

  return (
    <div className="game-page">
      <div className="game-header">
        <Link to="/" className="back-link">
          ← Back to Games
        </Link>
        <div className="game-title">
          <h1>Wavelength</h1>
        </div>
      </div>
      
      <div className="game-content">
        {!gameStarted ? (
          <>
            <section className="game-info-section">
              <h2>How to Play</h2>
              <p>
                Wavelength is a social guessing game where teams compete to read each other's minds.
              </p>
              <p>
                Teams take turns. One player (the psychic) sees a target along a spectrum between two opposing concepts (e.g., "Hot vs. Cold" or "Good vs. Evil").
              </p>
              <p>
                The psychic gives a one-word clue to help their team find the location of the target on the spectrum. The team then discusses and places a dial where they think the target is located.
              </p>
              <p>
                Points are scored based on how close the team gets to the target. The closer to the bullseye, the more points earned.
              </p>
              <p>
                The opposing team can also score points by predicting whether the active team's guess is to the left or right of the actual target.
              </p>
              <p>
                Teams alternate turns, and the first team to reach the target score wins!
              </p>
            </section>
            
            <section className="game-info-section">
              <h2>Game Components</h2>
              <ul>
                <li>A spectrum dial with a hidden target area</li>
                <li>Cards with opposing concepts (like "Hot vs. Cold")</li>
                <li>Team tokens for scoring</li>
              </ul>
            </section>
            
            <section className="game-action">
              <button 
                className="action-button"
                onClick={handleNewGame}
              >
                Start Game
              </button>
            </section>
          </>
        ) : (
          <>
            <div className="game-navigation">
              <button 
                className="back-to-instructions"
                onClick={handleBackToInstructions}
              >
                Back to Instructions
              </button>
              {gameCode && (
                <div className="share-code">
                  <p>Share this game: <strong>{window.location.href}</strong></p>
                </div>
              )}
            </div>
            {/* Component for the actual game will be added here later */}
            <div className="wavelength-game-placeholder">
              <h2>Game Coming Soon!</h2>
              <p>The Wavelength game implementation is under development.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Wavelength; 